import { Box, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import 'aos/dist/aos.css'; // Keep AOS styles for compatibility

const Billboard = ({ adds = [] }) => {
  const [currentAdIndex, setCurrentAdIndex] = useState(0);

  // Filter ads to only include type 'Billboard'
  const billboardAds = Array.isArray(adds)
    ? adds.filter((item) => item.type === 'Billboard')
    : [];

  // Slideshow effect for multiple ads
  useEffect(() => {
    if (billboardAds.length > 1) {
      const interval = setInterval(() => {
        setCurrentAdIndex((prevIndex) =>
          (prevIndex + 1) % billboardAds.length
        );
      }, 10000); // Increased to 4s to allow animation completion

      return () => clearInterval(interval);
    }
  }, [billboardAds]);

  // Handle edge cases
  if (billboardAds.length === 0) {
    console.warn("Billboard component: No valid billboard ads", adds);
    return (
      <Box
        sx={{
          width: '100%',
          height: '250px',
          overflow: 'hidden',
          backgroundColor: '#fff',
        }}
        data-aos="fade-up"
      >
        <Typography>No billboard ads available</Typography>
      </Box>
    );
  }

  const currentAd = billboardAds[currentAdIndex];

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      sx={{
        width: '100%',
        height: { xs: '18vh', sm: '25vh', md: '300px' },
        overflow: 'hidden',
        backgroundColor: '#fff',
        position: 'relative',
      }}
    >
      <style>
        {`
          @keyframes slideInOut {
            0% {
              transform: translateX(100%);
              opacity: 0;
            }
            10%, 90% {
              transform: translateX(0);
              opacity: 1;
            }
            100% {
              transform: translateX(-100%);
              opacity: 0;
            }
          }
          .billboard-image {
            animation: slideInOut 10s ease-in-out forwards;
            max-width: 100%;
            object-fit: cover;
            position: absolute;
            top: 50% -50%;
            left: 50% - 50%;
          }
        `}
      </style>
      <img
        className="billboard-image"
        src={
          currentAd.image
            ? `https://mindsinaction.com.na/assets/media/pictures/${currentAd.image}`
            : `https://mindsinaction.com.na/assets/media/pictures/${currentAd.video}`
        }
        alt={currentAd.title || 'Billboard Ad'}
        key={currentAdIndex} // Ensure animation retriggers
      />
    </Box>
  );
};

export default Billboard;